import React, { useState } from "react";
import styled from "styled-components";
import { DARK_KUBBE, PRIMARY_KUBBE } from "../../../constants/Colors";

const AccordionContainer = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 40px 20px;
  border-radius: 10px;
`;

const AccordionItem = styled.div`
  border-bottom: 1px solid #ccc;
  padding: 15px 0;
`;

const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const Title = styled.h3`
  color: ${DARK_KUBBE};
  font-size: 1.2rem;
  font-weight: bold;
  margin: 0;
`;

const Icon = styled.span`
  font-size: 1.5rem;
  font-weight: bold;
  color: ${PRIMARY_KUBBE};
  transition: transform 0.2s ease;

  ${(props) => props.isOpen && "transform: rotate(180deg);"}
`;

const Content = styled.div`
  margin-top: 10px;
  font-size: 1rem;
  color: ${DARK_KUBBE};
  line-height: 1.5;
  max-height: ${(props) => (props.isOpen ? "500px" : "0")};
  overflow: hidden;
  transition: max-height 0.3s ease;
`;

const Accordion = ({ data }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <AccordionContainer>
      {data.map((item, index) => (
        <AccordionItem key={index}>
          <AccordionHeader onClick={() => toggle(index)}>
            <Title>{item.title}</Title>
            <Icon isOpen={openIndex === index}>
              {openIndex === index ? "-" : "+"}
            </Icon>
          </AccordionHeader>
          <Content isOpen={openIndex === index}>{item.content}</Content>
        </AccordionItem>
      ))}
    </AccordionContainer>
  );
};

export default Accordion;
